/* tslint:disable */

declare var Object: any;
export interface CostCenterServiceInterface {
  "id"?: number;
}

export class CostCenterService implements CostCenterServiceInterface {
  "id": number;
  constructor(data?: CostCenterServiceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `CostCenterService`.
   */
  public static getModelName() {
    return "CostCenterService";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of CostCenterService for dynamic purposes.
  **/
  public static factory(data: CostCenterServiceInterface): CostCenterService{
    return new CostCenterService(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'CostCenterService',
      plural: 'CostCenterServices',
      path: 'CostCenterServices',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/CostCenterService.ts